module.exports = __webpack_public_path__ + "img/list.389696df.png";